export default "__VITE_ASSET__lCn$mfmf__"